const and = (pre, post) => value => pre(value) && post(value);

export default and;
